export default "__VITE_ASSET__CMS6s3ok__"